import React from 'react';

export interface CalendarEventIconProps {
  style?: React.CSSProperties;
}

export const CalendarEventIcon = ({ style }: CalendarEventIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="21"
      viewBox="0 0 17 21"
      fill="none"
      style={style}
    >
      <path
        d="M1.71647 20.1334C1.22736 20.1334 0.81901 19.9704 0.491406 19.6446C0.163802 19.3187 0 18.9126 0 18.4261V4.9315C0 4.44501 0.163802 4.03884 0.491406 3.71299C0.81901 3.38713 1.22736 3.22421 1.71647 3.22421H3.59603V0.866699H4.74034V3.22421H12.3415V0.866699H13.404V3.22421H15.2835C15.7726 3.22421 16.181 3.38713 16.5086 3.71299C16.8362 4.03884 17 4.44501 17 4.9315V18.4261C17 18.9126 16.8362 19.3187 16.5086 19.6446C16.181 19.9704 15.7726 20.1334 15.2835 20.1334H1.71647ZM1.71647 19.0765H15.2835C15.4472 19.0765 15.5971 19.0088 15.7332 18.8734C15.8694 18.7379 15.9375 18.5888 15.9375 18.4261V9.15879H1.0625V18.4261C1.0625 18.5888 1.13059 18.7379 1.26677 18.8734C1.40294 19.0088 1.55284 19.0765 1.71647 19.0765ZM1.0625 8.10171H15.9375V4.9315C15.9375 4.76875 15.8694 4.61965 15.7332 4.4842C15.5971 4.34875 15.4472 4.28103 15.2835 4.28103H1.71647C1.55284 4.28103 1.40294 4.34875 1.26677 4.4842C1.13059 4.61965 1.0625 4.76875 1.0625 4.9315V8.10171Z"
        fill="#383838"
      />
    </svg>
  );
};

export default CalendarEventIcon;
